const e={MuiSelect:{styleOverrides:{select:{"&":{backgroundColor:"transparent"}}}}};export{e as default};
//# sourceMappingURL=MuiSelect.js.map
